export default {
  "7e114ac94166f7e763dcb44d63aa8e1a": "下单页",
  "b5fe836a6d3fbbc5e95129cead17d40e": "扩科组件曝光",
  "c2af4fcf5b90cb9f179e3cdce608a2ee": "商城订单确认页_优惠券挽留弹窗_确认按钮",
  "57950bd46fa47fb8fcea3b20c1c288fb": "收下并使用",
  "bcbd6b44312685a43800b922f199df8a": "领取失败",
  "f644fb9a4519355a8da1f64fc94edb66": "该商品暂时无法购买，请联系客服",
  "8ce562997645526239623f8f72931c3c": "未选择地址",
  "19468132a5f1e5c21f8b70574a6ba49f": "未选择支付方式",
  "cad27f9072af037e76552b1bb37a4f3c": "确认订单收银台-立即支付按钮点击",
  "890ca4dbf6dcad1eac1ae40d607f73e3": "优惠券ID：",
  "efcbc88e75d142089eede97f8289b645": "; 代金券ID：",
  "281253962349ff8082ff1027931ef76b": "; 合计价格：",
  "f05994bf4fe507e9d499dc42fccec46e": "商城订单确认页_底部按钮",
  "7c80332494d33b2f1f87a723cac1707f": "商城订单确认页_优惠券点击",
  "321ae2d2073ac59fe31b3f509bbdd216": "已下架",
  "b202d974ceeb3ede24e96c1fa17e93ac": "已售罄",
  "a69f3d24912fea7a6ef769b797449edb": "成长豆不足",
  "9342234c70c7ff04efb8d1dd341413ac": "立即兑换",
  "3e0cf6cf25dfa2f8d13908dcffbd300b": "立即支付",
  "23b9a391df9da79cd38db19850f855cb": "参数错误!",
  "12836810affe0aa90138d03ae352abcc": "支付中...",
  "8a81f31b60bcf273bb047297ea3f1dcd": "商品明细",
  "157d7443e1302a3f587cfa43f81efd0a": "价格明细",
  "4928e9df06efbb05832f40151a973615": "支付方式",
  "44d98997d8ccb61062c3425a262b4add": "成长豆兑换商品 若无质量问题不支持退换货",
  "008c885d00e7761df2e800e58558ff2c": "商品详情页_挽留 弹窗曝光",
  "3049a87611b81d01f2521faa8a90b239": "商城",
  "78c923976c120f18344800b3e37eb85c": "商品详情页_挽留弹窗内容按钮点击",
  "87c126344a8907ba094a10364e87813e": "其他",
  "9d8aaf677170687608ead4dca1058592": "商品详情页_挽留弹窗底部按钮点击",
  "25faa1bbd1c61e39fbaee2ea6c799012": "放弃"
}
